import React from "react";
import {
  Box,
  Typography,
  Switch,
  FormControlLabel,
  Button,
} from "@mui/material";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";

interface OrderHeaderProps {
  onBack: () => void;
  useEnhancedUI: boolean;
  onToggleUI: (enabled: boolean) => void;
  title?: string;
}

const OrderHeader: React.FC<OrderHeaderProps> = ({
  onBack,
  useEnhancedUI,
  onToggleUI,
  title = "Create New Order",
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "stretch", sm: "center" },
        justifyContent: "space-between",
        gap: { xs: 2, sm: 0 },
        mb: 3,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          flexDirection: { xs: "column", sm: "row" },
          textAlign: { xs: "center", sm: "left" },
        }}
      >
        <Button
          startIcon={<ArrowLeftIcon className="h-5 w-5" />}
          onClick={onBack}
          variant="outlined"
          size="small"
        >
          Back to Orders
        </Button>
        <Typography
          variant="h4"
          component="h1"
          sx={{ fontSize: { xs: "1.5rem", sm: "2rem" } }}
        >
          {title}
        </Typography>
      </Box>

      {/* UI Toggle */}
      {/* <FormControlLabel
        control={
          <Switch
            checked={useEnhancedUI}
            onChange={(e) => onToggleUI(e.target.checked)}
            color="primary"
          />
        }
        label={useEnhancedUI ? "Enhanced UI" : "Classic UI"}
        sx={{ alignSelf: { xs: 'center', sm: 'flex-start' } }}
      /> */}
    </Box>
  );
};

export default OrderHeader;
